import RequestPageTwo from "./RequestPageTwo";

const OrdinationReq = () => {
    return (
        <RequestPageTwo title="Ordinaion Request form"
            fetchUrl="/get-ordination-requests"
            editEndpoint="update-ordination-requests"
            deleteEndpoint="ordination-requests"
            statusEndpoint="update-ordination-requests" />
    );
}

export default OrdinationReq;
